import * as types from './actionTypes';

export const addCardAction = cardActionToAdd =>({
    type: types.ADD,
    cardActionToAdd
});

export const removeCardAction = (cardActionId,position) =>({
    type: types.REMOVE,
    position,
    cardActionId
});

export const updateCardAction = cardAction =>({
    type: types.UPDATE,
    cardAction
});

export const setActions = actions => ({
    type: types.SET,
    cardActions: actions
});